import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

const OrderStatusSteps = ({ orderData }) => {

    const isBillingSuccess = ["P", "C", "S"].includes(
        orderData?.billing_status 
    );

    const steps = [
        {
            id: 1,
            label: "PV1",
            completed: !!orderData?.pv1_timestamp,
            color: "success",
            tooltip: orderData?.pv1_timestamp
                ? moment(orderData.pv1_timestamp).format("MM/DD/YY, hh:mm A")
                : "Pending"
        },
        {
            id: 2,
            label: "Billing",
            completed: !!orderData?.billing_timestamp,
            color:
                orderData?.billing_timestamp
                    ? isBillingSuccess
                        ? "success"
                        : "warning"
                    : "secondary",
            tooltip: orderData?.billing_timestamp
                ? (
                    <>
                        <div><b>Status:</b> {orderData.billing_status}</div>
                        <div>
                            <b>Created:</b>{" "}
                            {orderData.billing_date
                                ? moment(orderData.billing_date).format("MM/DD/YY")
                                : "-"}
                        </div>
                        <div>
                            <b>Timestamp:</b>{" "}
                            {moment(orderData.billing_timestamp).format(
                                "MM/DD/YY, hh:mm A"
                            )}
                        </div>
                    </>
                )
                : "Pending"
        },
        {
            id: 3,
            label: "Filling",
            completed: !!orderData?.filling_timestamp,
            color: "success",
            tooltip: orderData?.filling_timestamp
                ? moment(orderData.filling_timestamp).format(
                    "MM/DD/YY, hh:mm A"
                )
                : "Pending"
        },
        {
            id: 4,
            label: "PV2",
            completed: !!orderData?.pv2_timestamp,
            color: "success",
            tooltip: orderData?.pv2_timestamp
                ? moment(orderData.pv2_timestamp).format(
                    "MM/DD/YY, hh:mm A"
                )
                : "Pending"
        }
    ];

    const getColor = (step) => {
        if (!step.completed) return "#dee2e6";
        if (step.color === "warning") return "#ffc107";
        return "#28a745";
    };

    return (
        <div className="d-flex align-items-center justify-content-between mb-4 px-2">
            {steps.map((step, index) => (
                <React.Fragment key={step.id}>
                    <div className="text-center flex-grow-1">

                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    {step.tooltip}
                                </Tooltip>
                            }
                        >
                            <div
                                style={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: "50%",
                                    margin: "0 auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    transition: "all .25s ease",
                                    backgroundColor: getColor(step)
                                }}
                            >
                                {step.completed ? (
                                    <FontAwesomeIcon icon="check" />
                                ) : (
                                    step.id
                                )}
                            </div>
                        </OverlayTrigger>

                        <div
                            className="mt-2 small fw-semibold"
                            style={{
                                color: step.completed ? "#212529" : "#adb5bd"
                            }}
                        >
                            {step.label}
                        </div>
                    </div>

                    {/* Connector */}
                    {index !== steps.length - 1 && (
                        <div
                            style={{
                                height: 2,
                                flex: 1,
                                backgroundColor:
                                    steps[index].completed
                                        ? "#28a745"
                                        : "#dee2e6"
                            }}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default OrderStatusSteps;